import { Duration } from 'dayjs/plugin/duration';

export const formatDuration = (duration: Duration) => {
  const hours = Math.trunc(duration.asHours()); // rm under hours values

  const minutes = duration.minutes().toString().padStart(2, '0');

  const formattedDuration = `${hours}:${minutes}`;

  return formattedDuration;
};
